import { withI18n } from 'lingui-react';
import { compose, setDisplayName } from 'recompose';
import { withTheme } from 'styled-components';

import onlyUpdateForPropTypes from 'utils/onlyUpdateForPropTypes';
import useContext from 'utils/useContext';

import { CaseStatusContext } from 'compositions/CaseStatus';

import withDealers from '../withDealers';
import withIsRouteSearch from '../withIsRouteSearch';
import withLocations from '../withLocations';

import SearchInputComponent from './SearchInputComponent';

export default compose(
  setDisplayName('DealerLocator__SearchInput'),
  withI18n(),
  withDealers,
  withIsRouteSearch,
  withLocations,
  withTheme,
  useContext(CaseStatusContext, false),
  onlyUpdateForPropTypes,
)(SearchInputComponent);



// WEBPACK FOOTER //
// ./src/compositions/DealerLocator/SearchInput/index.js